export default __webpack_public_path__ + "static/media/Icon_Cross.7521a292.svg";